/**
 * Generates a random alphanumeric string using A-Z, a-z, 0-9.
 * Length must be at least 1. Returned string preserves case.
 */
export const createRandomString = (length: number, includeLowercase?: boolean): string => {
  if (length <= 0) return "";
  let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  if (includeLowercase) {
    chars = `${chars}abcdefghijklmnopqrstuvwxyz`;
  }

  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};
